var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasLastOrder || _vm.adminRole)?_c('v-btn',{staticClass:"noPadding",attrs:{"text":"","color":"primary","to":{
      name: 'RegionOrder',
      params: { regionId: this.regionId }
    },"title":_vm.$t('order.addDataToOrder')}},[_c('v-icon',{staticClass:"pb-1 pt-1",attrs:{"dense":""}},[_vm._v(" mdi-plus-circle")]),_vm._v(" "+_vm._s(_vm.$t("order.orderNewData"))+" ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }